/*!
 * CHIEF - Cybersecurity Learning Platform (PROPRIETARY SOFTWARE)
 * Main Entry Point
 * 
 * Copyright (c) 2025 Srivatsan Sk. All rights reserved.
 * 
 * PROPRIETARY LICENSE NOTICE:
 * This software is the exclusive proprietary property of Srivatsan Sk.
 * Licensed to client under strict commercial license agreement.
 * Unauthorized use, copying, modification, distribution, or removal
 * of copyright notices is strictly prohibited.
 * 
 * Original Author: Srivatsan Sk
 * License: Proprietary/Commercial
 * Status: Confidential
 * 
 * WARNING: This code contains proprietary business logic and algorithms.
 * Reverse engineering, decompilation, or derivative works are prohibited.
 */

// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Add this line
import './styles/App.css'; // Add this line
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { theme, GlobalStyles } from './styles/theme';
import { AuthProvider } from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';

// PROPRIETARY SOFTWARE NOTICE - DO NOT REMOVE
console.log('%c⚠️  PROPRIETARY SOFTWARE NOTICE', 'color: #ff4444; font-size: 16px; font-weight: bold; background: #000; padding: 8px;');
console.log('%c🛡️ CHIEF Platform | Proprietary Software by Srivatsan Sk', 'color: #00d2ff; font-size: 14px; font-weight: bold;');
console.log('%c© 2025 TheCyberHub. All rights reserved. Unauthorized use prohibited.', 'color: #666; font-size: 12px;');
console.log('%cThis software is protected by copyright law. Removal of author credits is prohibited.', 'color: #ff8800; font-size: 11px;');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        <AuthProvider>
          <NotificationProvider>
            <App />
          </NotificationProvider>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);